import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Checkbox } from '../ui/checkbox';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Heartbeat } from '@phosphor-icons/react';

const CTC_OPTIONS = ['COOL', 'CLAMMY', 'WARM', 'DRY', 'NORMAL'];

export function VitalSignsSection({ formData, handleNestedChange, handleInputChange }) {
  return (
    <Card className="border-slate-200">
      <CardHeader className="pb-4">
        <div className="flex items-center justify-between">
          <CardTitle className="text-xl flex items-center gap-2">
            <Heartbeat size={24} className="text-purple-600" />
            Vital Signs *
          </CardTitle>
          <div className="flex items-center space-x-2">
            <Checkbox
              id="vitals_na"
              checked={formData.vitals_na}
              onCheckedChange={(checked) => handleInputChange('vitals_na', checked)}
              data-testid="vitals-na-checkbox"
            />
            <Label htmlFor="vitals_na" className="text-sm text-slate-700 cursor-pointer font-medium">
              N/A - No vitals taken
            </Label>
          </div>
        </div>
      </CardHeader>
      <CardContent className={formData.vitals_na ? 'opacity-50 pointer-events-none' : ''}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {[1, 2, 3, 4].map((setNum) => {
            const key = `vital_signs_${setNum}`;
            const vs = formData[key] || {};
            return (
              <div key={setNum} className="space-y-4 p-4 bg-slate-50 rounded-sm">
                <h4 className="font-semibold text-slate-700">Vital Signs - Set {setNum}</h4>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-500">Time</Label>
                    <Input
                      type="time"
                      value={vs.time || ''}
                      onChange={(e) => handleNestedChange(key, 'time', e.target.value)}
                      className="rounded-sm border-slate-300 text-sm"
                      data-testid={`vitals${setNum}-time-input`}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-500">Pulse</Label>
                    <Input
                      value={vs.pulse || ''}
                      onChange={(e) => handleNestedChange(key, 'pulse', e.target.value)}
                      placeholder="bpm"
                      className="rounded-sm border-slate-300 text-sm"
                      data-testid={`vitals${setNum}-pulse-input`}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-500">Blood Pressure</Label>
                    <Input
                      value={vs.blood_pressure || ''}
                      onChange={(e) => handleNestedChange(key, 'blood_pressure', e.target.value)}
                      placeholder="mmHg"
                      className="rounded-sm border-slate-300 text-sm"
                      data-testid={`vitals${setNum}-bp-input`}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-500">Respiration</Label>
                    <Input
                      value={vs.respiration || ''}
                      onChange={(e) => handleNestedChange(key, 'respiration', e.target.value)}
                      placeholder="/min"
                      className="rounded-sm border-slate-300 text-sm"
                      data-testid={`vitals${setNum}-resp-input`}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-500">O2 Saturation</Label>
                    <Input
                      value={vs.o2_saturation || ''}
                      onChange={(e) => handleNestedChange(key, 'o2_saturation', e.target.value)}
                      placeholder="%"
                      className="rounded-sm border-slate-300 text-sm"
                      data-testid={`vitals${setNum}-o2-input`}
                    />
                  </div>
                  <div className="space-y-1">
                    <Label className="text-xs text-slate-500">CTC</Label>
                    <Select value={vs.ctc || ''} onValueChange={(value) => handleNestedChange(key, 'ctc', value)}>
                      <SelectTrigger className="rounded-sm border-slate-300 text-sm" data-testid={`vitals${setNum}-ctc-input`}>
                        <SelectValue placeholder="Select" />
                      </SelectTrigger>
                      <SelectContent>
                        {CTC_OPTIONS.map((opt) => (
                          <SelectItem key={opt} value={opt}>{opt}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
}
